import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { TranslocoDirective } from "@jsverse/transloco";
import { FieldType, FieldTypeConfig, FormlyFieldConfig } from "@ngx-formly/core";

export function isTextDisplayField(field: FormlyFieldConfig): field is FormlyFieldConfig & {
  type: "textDisplay";
} {
  return field.type === "textDisplay";
}

@Component({
  selector: "app-formly-text-display",
  templateUrl: "./text-display.type.html",
  standalone: true,
  imports: [CommonModule, TranslocoDirective],
})
export class TextDisplayComponent extends FieldType<FieldTypeConfig> {
  constructor() {
    super();
  }

  get displayValue(): string {
    const value = this.formControl.value;
    if (value === null || value === undefined) {
      return "";
    }
    return String(value);
  }
}
